
import home from "../../../Assets/Img/home.png"
import chat from "../../../Assets/Img/chat.png"
import page from "../../../Assets/Img/page.png"
import box from "../../../Assets/Img/box.png"
import cloud from "../../../Assets/Img/cloud.png"
import contactUs from "../../../Assets/Img/contactUs.png"
import bag from "../../../Assets/Img/bag.png"
import hat from "../../../Assets/Img/hat.png"
import youtube from "../../../Assets/Img/youtube.png"

const MoreData = [
    {
        Img:home,
        Link:"/homePage"

    },
    {
        Img:chat,
        Link:"/homePage"
    },
    {
        Img:page,
        Link:"/homePage"
    },
    {
        Img:box,
        Link:"/homePage"
    },
    {
        Img:cloud,
        Link:"/homePage"
    },
    {
        Img:contactUs,
        Link:"/ContactUs"
    },
    {
        Img:bag,
        Link:"/homePage"
    },
    {
        Img:hat,
        Link:"/homePage"
    },
    {
        Img:youtube,
        Link:"/https://www.youtube.com/watch?v=IJS2lVdR6GU"
    }
]
export default MoreData